import { getBackendUrl } from "../config";

const isAbsoluteUrl = value => /^https?:\/\//i.test(value || "");

const resolveContactPictureUrl = contact => {
  if (!contact) return "";

  const urlPicture = contact.urlPicture || contact.profilePicUrl || "";
  if (!urlPicture) return "";

  // Already a full URL (http:// or https://) - return as-is
  if (isAbsoluteUrl(urlPicture)) {
    return urlPicture;
  }

  // Get backend URL or use current origin as fallback
  let backendUrl = getBackendUrl();
  
  // If no backend URL is configured, use the current window origin
  // This ensures we always return an absolute URL to prevent browser relative path issues
  if (!backendUrl && typeof window !== "undefined") {
    backendUrl = window.location.origin;
  }
  
  // Still no URL available - return empty to avoid broken images
  if (!backendUrl) {
    return "";
  }

  // If it's an absolute path starting with /, prepend the backend URL
  if (urlPicture.startsWith("/")) {
    return `${backendUrl}${urlPicture}`;
  }

  // If it's just a filename and we have companyId, construct the full path
  if (contact.companyId && !urlPicture.includes("/")) {
    return `${backendUrl}/public/company${contact.companyId}/contacts/${urlPicture}`;
  }

  // Fallback - prepend backend URL with /
  return `${backendUrl}/${urlPicture}`;
};

export default resolveContactPictureUrl;
